import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  NgbModal,
  NgbTypeaheadSelectItemEvent,
} from "@ng-bootstrap/ng-bootstrap";
import { OperatorFunction } from "rxjs/interfaces";
import { Observable } from "rxjs/Observable";
import { debounceTime, distinctUntilChanged, mergeMap } from "rxjs/operators";

import { fromPromise } from "rxjs/observable/fromPromise";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import { DiscountManagementService } from "../../../_services/discount-management.service";
import { ServerNamespace } from "../../../_models/server/server-namespace";
import { trimTextByWord } from "../../events-screen/utils/trimTextByWord";
import { ReceiptManagementService } from "../../../_services/receipt-management.service";

@Component({
  selector: "receipt-page-search-event",
  templateUrl: "./receipt-page-search-event.component.html",
  styleUrls: [
    "../receipt-page-search-child/receipt-page-search-child.component.scss",
    "receipt-page-search-event.component.scss",
  ],
})
export class ReceiptPageSearchEventComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild("resultTemplate") public resultTemplate;
  @ViewChild("autoCompleteInput") public autoCompleteInput: ElementRef;
  public translations$: Observable<ITranslations>;
  @Output("eventSelected")
  public parentEventSelectionEvent: EventEmitter<ServerNamespace.GetParentEventForSubsidySearch | null> =
    new EventEmitter<ServerNamespace.GetParentEventForSubsidySearch | null>();
  public selectedEvent: ServerNamespace.GetParentEventForSubsidySearch | null =
    null;

  constructor(
    private modalService: NgbModal,
    private receiptManagementService: ReceiptManagementService,
    private translationService: TranslationService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public ngOnInit(): void {}

  public searchHandler: OperatorFunction<string, any> = (
    text$: Observable<any>
  ) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      mergeMap((term): any => {
        return fromPromise(
          this.receiptManagementService.searchEventByText(term)
        );
      })
    );

  public formatter = (x: { name: string }) => x.name;

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {}

  public getResultTemplate() {
    return this.resultTemplate;
  }

  public eventSelected($event: NgbTypeaheadSelectItemEvent) {
    $event.preventDefault();
    const childSelected =
      $event.item as ServerNamespace.GetParentEventForSubsidySearch;
    this.selectedEvent = childSelected;
    this.parentEventSelectionEvent.emit(childSelected);
  }

  public disableClick($event, stop: boolean) {
    if (!stop) {
      return;
    }
    $event.stopPropagation();
    $event.stopImmediatePropagation();
  }

  public cancelSelectedEvent() {
    this.selectedEvent = null;
    this.parentEventSelectionEvent.emit(null);
    this.autoCompleteInput.nativeElement.value = "";
  }
  public trimText(text: string): string {
    text = text.replace(/\s,/g, ",");
    return trimTextByWord(text, 50);
  }

  public searchBoxKeyDown($event: KeyboardEvent) {
    if (!this.selectedEvent) {
      return;
    }
    if ($event.key === "Backspace" || $event.key === "Delete") {
      this.cancelSelectedEvent();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-page-search-event/receipt-page-search-event.component.ts